import axios from "axios"
import { BASE_URL } from "../utils/constants"
import toast from "react-hot-toast"
import { handleApiError } from "../utils/handleApiError"

class PatientService {

  static getToken() {
    return localStorage.getItem("authToken")
  }

  static getTenant() {
    return sessionStorage.getItem("acc_id")
  }

  static getLocationId() {
    const location = sessionStorage.getItem("current_loc")
    return location ? JSON.parse(location)?.id : null
  }

  static getAuthHeaders(token = this.getToken()) {
    return {
      Authorization: `Bearer ${token}`,
    }
  }

  static async fetchPatients() {
    const token = this.getToken()
    const tenant = this.getTenant()
    const locationId = this.getLocationId()

    if (!locationId) {
      toast.error("No Active Location Found.")
      return { patients: [] }
    }

    try {
      const url = `${BASE_URL}/patients/${tenant}/${locationId}/patients/`
      const response = await axios.get(url, {
        headers: this.getAuthHeaders(token),
        params: { pagination: "false" }, // full list (endpoint paginates by default now)
      })

      return response.data
    } catch (error) {
      handleApiError(error)
      return { patients: [] }
    }
  }

  static async fetchAllPatients() {
    const token = this.getToken()
    const tenant = this.getTenant()

    try {
      const url = `${BASE_URL}/patients/${tenant}/patients/?type=all`
      const response = await axios.get(url, {
        headers: this.getAuthHeaders(token),
      })

      return response.data
    } catch (error) {
      handleApiError(error)
      return { patients: [] }
    }
  }

  static handleApiError(error) {
    if (!error.response) {
      toast.error("Network error. Please check your internet connection.")
    } else {
      toast.error(`An unexpected error occurred: ${error.response.statusText || "Unknown error"}`)
    }
    console.error("API Error:", error)
  }
}

export default PatientService